$(function () {
  const MAX_SIZE = 2;
  const RESERVED = 'RESERVED';
  const HOVERED = 'HOVERED';
  const TIME_UPDATE = 1.5;
  const MAX_EMPTY_TAIL = 0.2;
  const EMPTY_TAIL_CHANCE = 0.25;
  let tryFilled = false;
  let emptyInGrid = 0;
  const tileInGrid = new Map();
  const DETAIL_SIZE = {
    w: 3,
    h: 3
  };

  const GRID_PARAMS = {
    mobile: {
      w: 4,
      h: 4,
    },
    tablet: {
      w: 7,
      h: 4,
    },
    default: {
      w: 11,
      h: 4,
    }
  };

  const isMobile = window.matchMedia('only screen and (max-width: 640px)').matches;
  const isTablet = window.matchMedia('only screen and (max-width: 1000px)').matches;

  let sized = 'default';
  if (isMobile) {
    sized = 'mobile';
  } else if (isTablet) {
    sized = 'tablet';
  }

  const GRID_SIZE_X = GRID_PARAMS[sized].w;
  const GRID_SIZE_Y = GRID_PARAMS[sized].h;

  /*
  * мысля
  * 1. удалять по времени, на место тайла ставить заглушку (?)
  * 2. если новый тайл загораживает большой частично - большо разбиваем на мелкие и на его места встраиваем рандомные тайлы
  * 3. после начальной раскидки возможных вариантов - проходится по матрице и искать пустные или встраивать туда возмодные размеры начиная с максимального
  * 4. после всей растановки рандомно выбирать тайл и менять его по времени, логику см п2
  * 5. при наведении на блок и отображении подсказки - исключить изменение данного тайла - внести проверку при замене, см п2-3
  * 6. Сделать проверку на ширину экрана
  * 7. Сделать перестановку при ресайзе
  * */

  function createGridMatrix(sizeX, sizeY) {
    return Array(sizeY).fill(null).map(x => Array(sizeX).fill(null));
  }

  const mosaicContainer = document.getElementById('mosaic');
  const grid = createGridMatrix(GRID_SIZE_X, GRID_SIZE_Y);

  // tilesArray - сюда пихать данные о карточках

  let emptyCellCount = GRID_SIZE_X * GRID_SIZE_Y;

  let cellWidth;
  const styles = document.createElement('style');
  styles.setAttribute('type', 'text/css');
  document.head.appendChild(styles);

  const setParams = () => {
    styles.innerText = '';
    if (!isMobile) {
      cellWidth = Math.ceil(mosaicContainer.parentNode.offsetWidth / (GRID_SIZE_X - 1));
     } else {
      cellWidth = Math.ceil(mosaicContainer.parentNode.offsetWidth / (GRID_SIZE_X));
    }

    const rightMargin = -1 * cellWidth + 40;
    styles.appendChild(document.createTextNode(`.mosaic-tile__detail{width: ${cellWidth * DETAIL_SIZE.w}px; height: ${cellWidth * DETAIL_SIZE.h}px;}`));
    styles.appendChild(document.createTextNode(`.mosaic-tile__tags{flex: 0 1 ${cellWidth}px;}`));
    styles.appendChild(document.createTextNode(`.c-mosaic { margin-right: ${rightMargin}px;}`));
    styles.appendChild(document.createTextNode(`.mosaic-fix-tile--pull-right { padding-right: ${cellWidth + 20}px;}`));
    // mosaicContainer.style.width = `${cellWidth * GRID_SIZE_X}px`;
    mosaicContainer.style.height = `${cellWidth * GRID_SIZE_Y}px`;
  };

  function createFixedTile(el) {
    const [x, y, w, h] = el.dataset.params.split(',');
    return {
      tpl: el.outerHTML,
      x:+x, y: +y, w:+w, h: +h
    }
  }

  /**
   * замощение пустых мест
   */
  const fillGrid = () => {
    if (tryFilled) {
      return;
    }

    tryFilled = true;

    while (emptyCellCount > 0) {
      for (let x = 0; x < GRID_SIZE_X; x++) {
        for (let y = 0; y < GRID_SIZE_Y; y++) {
          let isEmpty = false;

          // проверяем на шанс пустой клетки
          if (Math.random() < EMPTY_TAIL_CHANCE && emptyInGrid < GRID_SIZE_X * GRID_SIZE_Y * MAX_EMPTY_TAIL) {
            isEmpty = true;
          }

          addTile(getRandomTile(), x, y, 1, 1, false, isEmpty);
        }
      }
    }

    tryFilled = false;
  };

  const detectInfoPosition = ({x, y, width, height}) => {
    let classess = [];
    if (x + width + DETAIL_SIZE.w < GRID_SIZE_X) {
      classess.push('pos--right');
    } else {
      classess.push('pos--left');
    }

    if (y + DETAIL_SIZE.h - 1 < GRID_SIZE_Y) {
      classess.push('pos--top');
    } else {
      classess.push('pos--bottom');
    }

    return classess;
  };

  /**
   * Создание тайла для размещения
   * @param tile
   * @param fixedTemplate
   * @param empty
   * @returns {{status: null, el: null, isEmpty: boolean, remove(): void}}
   */
  const createMosaicTile = (tile, fixedTemplate = '', empty = false) => {
    const newTile = {
      status: null,
      el: null,
      isEmpty: empty,
      remove() {
        newTile.el.classList.add('is-removed');

        newTile.el.removeEventListener('mouseenter', hoverHandler);
        newTile.el.removeEventListener('mouseleave', blurHandler);

        newTile.el.remove();

        delete newTile.el;
      },
      setPosition(cellWidth) {
        newTile.el.style.left = `${cellWidth * newTile.x}px`;
        newTile.el.style.top = `${cellWidth * newTile.y}px`;
        newTile.el.style.width = `${cellWidth * newTile.width}px`;
        newTile.el.style.height = `${cellWidth * newTile.height}px`;
      }
    };

    let el;
    if (tile.projectUrl) {
      el =  document.createElement('a');
      el.setAttribute('href', tile.projectUrl )
    } else {
      el = document.createElement('div');
    }
    el.classList.add('mosaic-tile');

    if (empty) {
      el.classList.add('mosaic-tile--empty');
    }

    if (fixedTemplate) {
      el.innerHTML = fixedTemplate;
    } else if (!empty) {
      const photo = Math.floor(Math.random() * tile.photos.length);

      el.innerHTML = `
	<div class='mosaic-tile__body' style="background-image: url(${tile.photos[photo]})"></div>
  <div class="mosaic-tile__detail">
    <div class="mosaic-tile__tags">${tile.tags}</div>
<!--    <div class="mosaic-tile__project">${tile.projectTitle}</div>-->
    <div class="mosaic-tile__title">${tile.projectName}</div>
    <div class="mosaic-tile__author">${tile.author}</div>
  </div>
    `;

      el.addEventListener('mouseenter', hoverHandler);

      el.addEventListener('mouseleave', blurHandler);
    }

    function hoverHandler() {
      newTile.status = HOVERED;
      const posClass = detectInfoPosition(newTile);
      el.classList.add(...posClass);
    }

    function blurHandler() {
      newTile.status = null;
    }

    newTile.el = el;

    return newTile;
  };

  /**
   * Добавление тайла
   * @param tile
   * @param x
   * @param y
   * @param width
   * @param height
   * @param reserved
   * @param empty
   * @returns {boolean}
   */
  const addTile = (tile, x, y, width = 1, height = 1, reserved = false, empty = false) => {
    // проверить что на месте ничего нет

    if (width === 0 || height === 0) {
      return false;
    }

    const size = width * height;
    if (emptyCellCount <= 0) {
      return false;
    }

    if (emptyCellCount - size < 0) {
      addTile(tile, x, y, width - 1, height - 1, reserved, empty);
    }

    const testResult = testCoords(x, y, width, height);

    if (testResult === true) {
      insetMosaicTile(tile, x, y, width, height, reserved, empty);

      if (empty) {
        emptyInGrid += 1;
      }
    }
  };

  /**
   *
   * @param tile
   * @param x
   * @param y
   * @param width
   * @param height
   * @param reserved
   * @param empty
   */
  const insetMosaicTile = (tile, x, y, width, height, reserved, empty) => {
    const mosaicElem = createMosaicTile(tile, tile.tpl, empty);
    mosaicElem.width = width;
    mosaicElem.height = height;
    mosaicElem.x = x;
    mosaicElem.y = y;

    for (let ix = 0; ix < width; ix++) {
      for (let iy = 0; iy < height; iy++) {
        const xx = x + ix;
        const yy = y + iy;
        grid[yy][xx] = reserved ? RESERVED : mosaicElem;
      }
    }

    mosaicElem.cellCount = width * height;
    emptyCellCount -= mosaicElem.cellCount;

    mosaicElem.setPosition(cellWidth);
    tileInGrid.set(mosaicElem, mosaicElem);

    mosaicContainer.appendChild(mosaicElem.el);
  };

  const replaceTile = (tile, x, y, width = 1, height = 1) => {
    if (width === 0 || height === 0) {
      return false;
    }

    const testResult = testCoords(x, y, width, height, true);
    if (testResult.length > 0) {

      const removedTiles = testResult;

      if (removedTiles.length > 0) {
        removedTiles.map(tile => {
          const {x, y, width, height} = tile;
          removeTile(tile, x, y, width, height);
        });
      }

      insetMosaicTile(tile, x, y, width, height);

      fillGrid(tilesArray);
    }

    return true;
  };


  const addFixedTile = (tile) => {
    addTile(tile, tile.x, tile.y, tile.w, tile.h, true);
  };

  const removeTile = (tile, x, y, width = 1, height = 1) => {
    for (let ix = 0; ix < width; ix++) {
      for (let iy = 0; iy < height; iy++) {
        const xx = x + ix;
        const yy = y + iy;
        grid[yy][xx] = null;
      }
    }

    emptyCellCount += width * height;

    if (tile.el && tile.el.classList) {
      try {
        tileInGrid.delete(tile);

        tile.remove();
        if (tile.isEmpty) {
          emptyInGrid -= 1;
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  /**
   * Проверка вхождение тайла в сетку и места для его размещения по коордиратам.
   * Вовзращает массив тайлов по данным координатам
   * @param x - координата
   * @param y - координата
   * @param width
   * @param height
   * @param onlyReserved - проверять только на зарезервированные клетки
   * @returns {boolean | Array}
   */
  const testCoords = (x, y, width = 1, height = 1, onlyReserved = false) => {
    const result = new Set();
    for (let ix = 0; ix < width; ix++) {
      for (let iy = 0; iy < height; iy++) {
        const xx = x + ix;
        const yy = y + iy;
        // выходит за пределы сетки
        if (xx >= GRID_SIZE_X || yy >= GRID_SIZE_Y) {
          return false;
        }

        const gridValue = grid[yy][xx];

        // если место занято фиксированным тайлом
        if (gridValue === RESERVED || gridValue && gridValue.status === HOVERED) {
          return false;
        }

        if (gridValue) {
          result.add(gridValue);
        }
      }
    }

    return result.size > 0 ? [...result] : true;
  };


  const getRandomSize = (range = MAX_SIZE) => {
    const width = Math.ceil(Math.random() * range);
    return {
      width: width,
      height: width === 1 ? 1 : Math.ceil(Math.random() * range),
    }
  };

  const getRandomCoords = () => {
    return {
      x: Math.floor(Math.random() * GRID_SIZE_X),
      y: Math.floor(Math.random() * GRID_SIZE_Y)
    }
  };

  const getRandomTile = () => {
    const index = Math.floor(Math.random() * tilesArray.length);
    return tilesArray[index];
  };

  const changeTile = () => {
    const {x, y} = getRandomCoords();
    const tile = getRandomTile();
    const {width, height} = getRandomSize(2);

    replaceTile(tile, x, y, width, height);
  };

  const onResize = () => {
    setParams();
    tileInGrid.forEach(tile => tile.setPosition(cellWidth));
  };

  function init() {
    if (!document.querySelector('.c-mosaic')) {
      return false;
    }

    setParams();

    // размещение фиксированных элементов
    if (!isMobile) {
      const fixedElements = [...document.querySelectorAll('.c-mosaic__fixed-tiles .mosaic-fix-tile')];
      fixedElements.map(el => createFixedTile(el))
        .map(tile => addFixedTile(tile));
    }


    // const fixedOne = createTile('<div class="is-fixed mosaic-fix-tile mosaic-fix-tile--large" >страну меняют люди</div>');
    // const fixedTwo = createTile('<a class="is-fixed mosaic-fix-tile mosaic-fix-tile--pull-right" href="#">Все проекты</a>');

    // addFixedTile(fixedOne, 0, 2, 4, 2);
    // addFixedTile(fixedTwo, 8, 0, 3, 1);

    tilesArray.map(tile => {
      const {x, y} = getRandomCoords();
      const {width, height} = getRandomSize(2);
      addTile(tile, x, y, width, height);
    });

    fillGrid(tilesArray);

    setInterval(() => {
      changeTile()
    }, 1e3 * TIME_UPDATE);

    window.addEventListener('resize', onResize);

  }

  init();
});

